import React, { useState } from 'react';
import I18n from 'i18n-js';
import { RCButton, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { NudgeExploreIcon } from '@reverbdotcom/cadence/icons/react';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';

import BumpModalV2WithController from './footer_buttons/BumpButtonV2';
import { bumpRatePercentToDecimal, recommendationAmount } from '../bump/bump_helpers';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';
import { CTA_TYPE, INSIGHT, trackClicked, useTrackingContext, useTrackImpression } from './sellerRecommendationTracking';

interface Props {
  listing: Listing;
}

export default function LowVisibilityPresentment({ listing }: Props) {
  const [showBumpModal, setShowBumpModal] = useState(false);
  const bumpRate = listing.bumpRate?.rate || 0;
  const trackingContext = useTrackingContext();

  useTrackImpression(INSIGHT.HIGH_COMPETITION_NEW, listing.id, {
    recommendedBumpRate: recommendationAmount(listing) ?? undefined,
  });

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__low-visibility">
          <RCTextWithIcon icon={<NudgeExploreIcon />} placement="left" size="large">
            <span className="weight-bold">
              {I18n.t('discovery.listingsManagement.sellerListingCard.insights.lowVisibility.title')}
            </span>
          </RCTextWithIcon>
        </span>
        <RCTextUtility size="350">
          {I18n.t('discovery.listingsManagement.sellerListingCard.insights.lowVisibility.bumpToBoost')}
        </RCTextUtility>
        <RCButton
          variant="outlined"
          size="small"
          onClick={() => {
            trackClicked(INSIGHT.HIGH_COMPETITION_NEW, listing.id, CTA_TYPE.PROMOTE_WITH_BUMP, trackingContext);
            setShowBumpModal(true);
          }}
          fullWidth
        >
          {I18n.t('discovery.listingsManagement.sellerListingCard.promoteWithBump')}
        </RCButton>
      </div>

      <BumpModalV2WithController
        listingId={listing.id}
        bid={bumpRatePercentToDecimal(bumpRate)}
        showModal={showBumpModal}
        setShowModal={setShowBumpModal}
        listing={listing}
        sourceInsight={INSIGHT.HIGH_COMPETITION_NEW}
      />
    </>
  );
}
